import { writable, derived } from 'svelte/store';

export const currentPath = writable(window.location.pathname);

// Listen for popstate (back/forward navigation)
window.addEventListener('popstate', () => {
    currentPath.set(window.location.pathname);
});

export function navigate(path, options = {}) {
    if (typeof path === 'number') {
        window.history.go(path);
        return;
    }
    if (options.replace) {
        window.history.replaceState({}, '', path);
    } else {
        window.history.pushState({}, '', path);
    }
    // Only store the pathname (strip query string and hash) so matchPath() works correctly
    currentPath.set(window.location.pathname);
}

/**
 * Match a path pattern like "/supplies/:section" against a pathname.
 * Returns null if no match, or an object with extracted params.
 */
export function matchPath(pattern, pathname) {
    // Wildcard matches everything
    if (pattern === '*') return { params: {} };

    // Strip query string and hash from pathname before matching
    const cleanPathname = pathname.split('?')[0].split('#')[0];

    const patternParts = pattern.replace(/^\//, '').split('/');
    const pathParts = cleanPathname.replace(/^\//, '').split('/');

    if (patternParts.length !== pathParts.length) return null;

    const params = {};
    for (let i = 0; i < patternParts.length; i++) {
        if (patternParts[i].startsWith(':')) {
            params[patternParts[i].slice(1)] = decodeURIComponent(pathParts[i]);
        } else if (patternParts[i] !== pathParts[i]) {
            return null;
        }
    }
    return { params };
}
